<template>
  <section class="benefits-orthodontics container p-5 mt-md-5 ">
    <Title title="مزایای ارتودنسی نامرئی دندان"></Title>
    <div class="benefits-orthodontics-img mt-5 pt-4"><img src="@/assets/images/others/InvisibleOrthodontics.svg" alt=""></div>
    <div class="benefits-orthodontics-resp d-md-none pt-5">
      <ul class="text-right">
        <li><a class="text-color-black weight-light fontsize-large">نامرئی بودن</a></li>
        <li><a class="text-color-black weight-light fontsize-large">متحرک بودن</a></li>
        <li><a class="text-color-black weight-light fontsize-large"> تغذیه راحت تر</a></li>
        <li><a class="text-color-black weight-light fontsize-large"> ظاهر بهتر و زیباتر</a></li>
        <li><a class="text-color-black weight-light fontsize-large">   امکان برداشتن کوتاه مدت</a></li>
      </ul>
    </div>
  </section>
</template>

<script>
import Title from "./Title";
export default {
  name: "BenefitsOrthodontics",
  components:{
    Title
  }
}
</script>

<style scoped>
.benefits-orthodontics-img{
  width: 100%;
  height: auto;
}
.benefits-orthodontics-img img{
  width: 100%;
}
.benefits-orthodontics-resp{
  background-image:url("../assets/images/backgrounds/backResp.png") ;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 90% auto;
}
.benefits-orthodontics-resp ul{
  list-style: none;
}
.benefits-orthodontics-resp ul>li{
  position: relative;
  padding-right: 3rem;
  margin-bottom: 2.5rem;
}
.benefits-orthodontics-resp ul>li:before{
  content: '';
  height: 25px;
  width: 25px;
  background-image: url("../assets/images/others/listStyleImg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);

}
@media screen and (max-width: 767px){
  .benefits-orthodontics-img{
    display: none;
  }
}
@media screen and (max-width: 500px){
  .benefits-orthodontics-resp {
    background-size: 100% auto;
  }
}
</style>